import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../../../../../../assets/css/applications.css';
import ic_bookings from '../../../../../../../../assets/icons/ic_bookings_blue.svg';
import { useDictionary } from '../../../../../../../../utilities/hooks/UseDictionary';
import { changeDocumentStatus } from '../../../networking';
import ApplicationDocumentItem from '../../../ApplicationDocumentItem';
import SimpleLoader from '../../../../../../common/SimpleLoader';

const ProviderDocuments = ({ files, onUpdated }) => {
	const dictionary = useDictionary();
	const [loading, setLoading] = useState(false);

	const changeDocumentStatusAsync = async (documentId, status) => {
		setLoading(true);
		try {
			await changeDocumentStatus(documentId, status);
			await onUpdated();
		} catch (error) {
			console.error('Error updating document status:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="settings-page-container thin-scrollbar fade-on-load">
			<div className="slot-detail-title" style={{ fontWeight: 500 }}>
				{dictionary.documents}
			</div>
			{files?.length > 0 ? (
				<div
					className="application-document-column"
					style={{ marginTop: 16 }}
				>
					{files.map((document) => (
						<ApplicationDocumentItem
							key={document.id}
							document={document}
							changeDocumentStatusAsync={changeDocumentStatusAsync}
						/>
					))}
				</div>
			) : (
				<div className="empty-participants-wrapper">
					<div className="empty-participants">
						<div className="empty-participants-icon-wrapper">
							<img src={ic_bookings} alt="No documents" />
						</div>
						<h5 className="empty-participants-title">
							{dictionary.no_files_uploaded_yet}
						</h5>
					</div>
				</div>
			)}
			<SimpleLoader showLoader={loading} />
		</div>
	);
};

ProviderDocuments.propTypes = {
	files: PropTypes.array,
	onUpdated: PropTypes.func.isRequired
};

export default ProviderDocuments;
